import {
  DeleteOutlined,
  EditOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import { Divider, Menu } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const DropdownMenu = ({ onDelete, onEdit, skill, onRunSkill }) => {
  const { t } = useTranslation();
  
  return (
    <Menu>
      <Menu.Item
        icon={<PlayCircleOutlined />}
        onClick={() => {
          onRunSkill(skill);
        }}
      >
        {t("skillsTable.actions.runSkill")}
      </Menu.Item>
      <Divider style={{ margin: "4px 0" }} />

      <Menu.Item
        icon={<EditOutlined />}
        onClick={() => {
          onEdit(skill);
        }}
      >
        {t("skillsTable.actions.viewEdit")}
      </Menu.Item>
      <Divider style={{ margin: "4px 0" }} />

      {/* <Menu.Item icon={<HistoryOutlined />} onClick={() => {}}>
        History
      </Menu.Item>
      <Divider style={{ margin: "4px 0" }} /> */}

      <Menu.Item
        icon={<DeleteOutlined />}
        onClick={() => {
          onDelete(skill.key);
        }}
      >
        {t("skillsTable.actions.delete")}
      </Menu.Item>
    </Menu>
  );
};

export default DropdownMenu;
